module.exports = __webpack_public_path__ + "img/double-quotes-r.30322c54.svg";